// extracted by mini-css-extract-plugin
export default {"pageLayout":"PlasmicPageLayout_pageLayout__d+qvh","sidenavSpacer":"PlasmicPageLayout_sidenavSpacer__0HTzM","slotPageContent":"PlasmicPageLayout_slotPageContent__jmVik"};